<template>
    <div class="main-wrapper">
        <layouts></layouts>
        
        <div class="page-wrapper">
           
                <indexexplore />
                
                <indexcategory />
                
                <indexfeatured />

                <indexpopular />

                <indexads />

                <indexcta />

                <indexclient />
            
                <indexpartners />

                <indexpricing />

                <indexblog />

                <foot />

                <scroll />
        </div>
    </div>
</template>

<script>

</script>